import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import { analytics } from '../lib/settings';
import { isEmpty, omit, path } from './fp';

const getIsGTMToken = () => !isEmpty(path(['CONFIG', 'gtmToken'], window));

export const getHasToken = () => {
  if (getIsGTMToken()) return true;
  return !isEmpty(path(['CONFIG', 'gaToken'], window));
};
//---------------------------------------------------------------------------------------initialize
export const initialize = ({ locale }) => {
  if (!getHasToken()) return;

  const { tagManagerArgs = {}, dataLayer = {} } = analytics;
  const gaToken = path(['CONFIG', 'gaToken'], window);
  const gtmToken = path(['CONFIG', 'gtmToken'], window);
  if (!isEmpty(gtmToken)) {
    if (!window.CONFIG.isProduction) {
      // eslint-disable-next-line no-console
      console.info(`google-tag-manager initialized with ${gtmToken}`);
    }
    TagManager.initialize({
      ...tagManagerArgs,
      gtmId: gtmToken,
      dataLayer: {
        ...dataLayer,
        event: 'page_view',
        site_name: window.location.host,
        site_environment: path(['CONFIG', 'siteEnv'], window),
        page_language: locale,
      },
    });
    return;
  }

  if (!window.CONFIG.isProduction) {
    // eslint-disable-next-line no-console
    console.info(`google-analytics initialized with ${gaToken}`);
  }
  ReactGA.initialize(gaToken);
  return;
};

// ---------------------------------------------------------------------------------------------lib
export const sendEvent = ({ dataLayer }) => {
  if (getIsGTMToken()) {
    return TagManager.dataLayer({
      dataLayer: omit(['category', 'action', 'label', 'isGTMEvent'], dataLayer),
    });
  }
  if (dataLayer?.isGTMEvent) return;
  // google analytics dont support gtm events
  ReactGA.event(dataLayer);
};
// ----------------------------------------------------------------------------------------------GA
export const joinDataflowIds = ({ datasourceId, dataflowId, agencyId, version }) =>
  [datasourceId, dataflowId, agencyId, version].map(v => v.replace(/@/g, '[at]')).join('/');

export const shareViewEvent = ({ customLabel, label, type, locale }) => {
  if (!getHasToken()) return;
  sendEvent({
    dataLayer: {
      ...analytics.dataLayer,
      category: 'SHARE_VIEW',
      action: `VIEWED_SHARED_${type}`,
      label,
      event: 'load_dataflow',
      customCategory: 'navigation',
      customAction: 'viewDataflow',
      customLabel,
      nonInteraction: true,
      pageLanguage: locale,
      isGTM: getIsGTMToken(analytics),
    },
  });
};
